import React from "react";
import PropTypes from "prop-types";
import { ErrorMessage } from "../../components/ErrorMessage";
import { Img } from "components";
import { useAppFont } from "../../utils/helper/useAppFont";

const TimeSlotRadio = React.forwardRef(
  (
    {
      inputClassName = "",
      className = "",
      name = "",
      children,
      label = "",
      checked = {},
      discount = 0,
      errors = [],
      onChange,
      id = "radio_id",
      ...restProps
    },
    ref
  ) => {
    const handleChange = (event) => {
      if (onChange) onChange(!!event?.target?.checked);
    };
    const { interClass } = useAppFont();
    console.log("discount------ag", discount);
    return (
      <>
        <div className={`flex flex-row gap-3 items-center ${interClass}`}>
          <div className={`${className} timeslot relative`}>
            <input
              className={`${inputClassName} invisible absolute top-0 ltr:left-0 rtl:right-0`}
              ref={ref}
              type="radio"
              name={name}
              aria-checked={checked?.slotId == checked?.id}
              checked={checked?.slotId == checked?.id}
              onChange={handleChange}
              {...restProps}
              id={id}
            />
            <label
              htmlFor={id}
              className={`cursor-pointer border border-solid border-gray-700 flex items-center justify-center w-full px-3 py-[5px] rounded`}
            >
              <Img
                className="h-[18px] mt-px"
                src="/images/img_checkmark_gray_900_01.svg"
                alt="checkmark"
              />
              <div className="text-center text-gray-900_01 text-sm font-nunitomedium">
                {label}
              </div>
            </label>
          </div>
          {discount > 0 && (
            <div className="w-fix py-1 px-4 rounded text-center bg-gray-50_02 text-[#222222] text-xs">
              {discount}% Discount
            </div>
          )}
        </div>
        <ErrorMessage errors={errors} />
        {children}
      </>
    );
  }
);

TimeSlotRadio.propTypes = {
  inputClassName: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
};

export { TimeSlotRadio };
